
<section class="section">

	<div class="section__title">Mi Comunidad</div>

	<div class="card-container">
		<ng-container *ngFor="let config of cardsConfig">
			<ng-container [ngTemplateOutlet]="card" [ngTemplateOutletContext]="{ config: config }"></ng-container>
		</ng-container>
	</div>

</section>

<!-- Card -->
<ng-template #card let-config="config">
	<div class="card__container" [gtagEvent]="'ver-' + config.key.toLowerCase()" gtagCategory="mi-comunidad">
		<!-- Card basado en managedLink-->
		<div *ngIf="!config.routerLink" class="card" [ngClass]="config.class" [managedLink]="config.key">
			<ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ config: config }"></ng-container>
		</div>
		<!-- Card basado en routerLink -->
		<div *ngIf="config.routerLink" class="card" [ngClass]="config.class" [routerLink]="config.routerLink">
			<ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ config: config }"></ng-container>
		</div>
	</div>
</ng-template>

<!-- Content -->
<ng-template #content let-config="config">
	<div class="content">
		<!-- Icon -->
		<div class="bg-icon"></div>
		<!-- Header -->
		<div class="card__header">
			<div class="card__icon-container"><div class="card__icon"></div></div>
			<div class="card__title">{{config.title}}</div>
		</div>
		<!-- Desc-->
		<div class="card__desc">{{config.desc}}</div>
	</div>
</ng-template>